import React from 'react';
import { credibilityData } from '../data/mockData';

const LogoBox = ({ item, index }) => {
  const getLogoStyle = (name) => {
    switch(name) {
      case 'Ford Models':
        return { transform: 'scale(1.2)' };
      default:
        return {};
    }
  };

  const glowColors = [
    'bg-pink-400/30',
    'bg-blue-400/30',
    'bg-teal-400/30',
  ];

  return (
    <div className="relative">
      <div className={`absolute inset-0 ${glowColors[index % glowColors.length]} rounded-lg blur-xl scale-110`} aria-hidden="true" />
      <div className="relative w-24 h-11 md:w-28 md:h-12 bg-stone-900 rounded-lg flex items-center justify-center overflow-hidden">
        <img 
          src={item.logo} 
          alt={`${item.name} logo`}
          className="object-contain brightness-0 invert"
          style={{ 
            maxWidth: '80%', 
            maxHeight: '80%',
            ...getLogoStyle(item.name) 
          }}
        />
      </div>
    </div>
  );
};

const CredibilityStrip = () => {
  const { title, items } = credibilityData;
  
  return (
    <section className="py-4 md:py-6 bg-white relative overflow-visible" aria-labelledby="credibility-heading">
      <div className="container mx-auto px-4 overflow-visible">
        {/* Section title */}
        <div className="text-center mb-4 md:mb-5">
          <h2 id="credibility-heading" className="text-stone-500 text-[9px] md:text-[10px] tracking-[0.3em] uppercase font-medium">
            {title}
          </h2>
        </div>
        
        {/* Logo grid */}
        <div className="overflow-visible py-4">
          <ul className="flex items-center justify-center flex-wrap gap-4 md:gap-6 list-none" aria-label="Partner organizations">
            {items.map((item, index) => (
              <li key={index} className="flex-shrink-0 flex flex-col items-center">
                <LogoBox item={item} index={index} />
                <p className="text-[8px] md:text-[9px] text-stone-500 mt-2 whitespace-nowrap">
                  {item.description}
                </p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default CredibilityStrip;
